























import mixins from 'vue-typed-mixins';
import { HumanResourcePlan } from '@/utils/HumanResourcesUtils';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => HumanResourcePlan,
    },
    question: {
      type: Object as () => Question,
    },
  },
  mounted() {
    if (!this.value.positioncount) {
      this.value.positioncount = {
        total: 0.0,
        nondbp: 0.0,
      };
    }
  },
});
